import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postTenantProjectStatusCleanup = (token, id, { cutoff_date }) => {
    return fetch(`${apiUrl}tenant_project_status_cleanup/${id}`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ cutoff_date }),
    });
};

export default postTenantProjectStatusCleanup;

